var _circle, _circle2, _circle3, _circle4, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _path, _text10, _path2, _text11, _path3, _text12, _circle5, _rect, _path4, _text13, _rect2, _path5, _rect3, _path6, _rect4, _path7, _text14, _text15, _text16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIslandWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 657.1 490.9"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    transform: "translate(233.5 75)",
    fill: "none",
    stroke: "#1a1311",
    strokeMiterlimit: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    transform: "translate(148.8 153.6)",
    fill: "none",
    stroke: "#1a1311",
    strokeMiterlimit: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    transform: "translate(233.5 234)",
    fill: "none",
    stroke: "#1a1311",
    strokeMiterlimit: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    transform: "translate(314.9 153.6)",
    fill: "none",
    stroke: "#1a1311",
    strokeMiterlimit: 10
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(290 111.5)",
    fill: "#1a1311",
    fontSize: 18,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u597D\u304D\u306A\u4E8B"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(287.1 143)",
    fill: "#1a1311",
    fontSize: 18,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Like/Love"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(156.6 245.1)",
    fill: "#1a1311",
    fontSize: 18,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u5F97\u610F\u306A\u4E8B"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(160.4 276.6)",
    fill: "#1a1311",
    fontSize: 18,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Good at"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(290 358.3)",
    fill: "#1a1311",
    fontSize: 18,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u7A3C\u3052\u308B\u4E8B"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(295.2 389.8)",
    fill: "#1a1311",
    fontSize: 18,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Paid for"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(465.1 167.5)",
    fill: "#1a1311",
    fontSize: 18,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u4E16\u754C\u304C\u6C42\u3081\u308B\u4E8B"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(434.4 199)",
    fill: "#1a1311",
    fontSize: 18,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "What the world NEEDS!"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(68.1 100.3)",
    fill: "#1a1311",
    fontSize: 18,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u60C5\u71B1"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Helvetica"
  }, " Passion"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1 108.5h130l85 93m0 102l-70 81H62.6",
    fill: "none",
    stroke: "#1a1311",
    strokeMiterlimit: 10
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(69.6 375.5)",
    fill: "#1a1311",
    fontSize: 18,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u5C02\u9580\u6027"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Helvetica"
  }, " Profession"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M385.1 303.5l65 81h133",
    fill: "none",
    stroke: "#1a1311",
    strokeMiterlimit: 10
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(465.3 375.5)",
    fill: "#1a1311",
    fontSize: 18,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u5929\u8077"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Helvetica"
  }, " Vocation"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M379.1 198.5l90-90h120",
    fill: "none",
    stroke: "#1a1311",
    strokeMiterlimit: 10
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(484.1 100.3)",
    fill: "#1a1311",
    fontSize: 18,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u4F7F\u547D"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Helvetica"
  }, " Mission"))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(294.9 216.1)",
    fill: "#399d26",
    opacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 57.5,
    rx: 12,
    transform: "translate(265.1)",
    fill: "#2c682a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M314.9 52.5l13 40.2 14.2-40.2",
    fill: "#2c682a"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(296.8 34.5)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u81EA\u7136\u304C\u597D\u304D"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 57.5,
    rx: 12,
    transform: "rotate(180 199.15 245.45)",
    fill: "#2c682a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M348.4 439.6l-13-40.1-14.1 40.1",
    fill: "#2c682a"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 85.9,
    height: 129,
    rx: 12,
    transform: "matrix(0 -1 1 0 0 294.5)",
    fill: "#2c682a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.8 265l40.1-13-40.1-14.1",
    fill: "#2c682a"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 129,
    rx: 12,
    transform: "rotate(-90 402.9 -125.2)",
    fill: "#2c682a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M534.3 257l-40.2-13 40.2-14.1",
    fill: "#2c682a"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(310.9 465.3)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u9069\u6B63\u8A55\u4FA1"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(27.2 234)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u30C7\u30B6\u30A4\u30CA\u30FC"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "\u30A8\u30F3\u30B8\u30CB\u30A2"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 42
  }, "\u30D7\u30ED\u30B0\u30E9\u30DE\u30FC"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(545.2 246.1)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u516B\u4E08\u5CF6\u767A\u5C55\u306B\u5BC4\u4E0E"))));
}
export default "data:image/svg+xml;base64,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";
export { SvgIslandWork as ReactComponent };